import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ConfiguracaoProdutoResponse } from '../../responses/produto/configuracao-produto.response';
import { ConfiguracaoProdutoRequest } from '../../requests/produto/configuracao-produto.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class ConfiguracaoProdutoService extends CommonService {
  // Ajuste a URL base conforme a configuração do seu environment.ts (ex: urlApiProduto)
  private readonly apiUrl: string = environment.urlApiProduto + 'ConfiguracaoProduto';

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  /**
   * Endpoint para buscar a configuração de produto da empresa.
   * Corresponde a: [HttpGet] /ConfiguracaoProduto
   */
  public get(): Observable<ConfiguracaoProdutoResponse> {
    return this.httpClient
      .get<ConfiguracaoProdutoResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para buscar lookups de configuração.
   * Corresponde a: [HttpGet] /ConfiguracaoProduto/lookup
   */
  public getLookup(): Observable<ConfiguracaoProdutoResponse> {
    const url = `${this.apiUrl}/lookup`;
    return this.httpClient
      .get<ConfiguracaoProdutoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para atualizar a configuração do produto.
   * Corresponde a: [HttpPut] /ConfiguracaoProduto/idConfiguracaoProduto/{idConfiguracaoProduto}
   * @param idConfiguracaoProduto ID da configuração a ser alterada.
   * @param request O corpo da requisição com os novos dados.
   */
  public put(idConfiguracaoProduto: number, request: ConfiguracaoProdutoRequest): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/idConfiguracaoProduto/${idConfiguracaoProduto}`;
    return this.httpClient
      .put<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}